import React, { useState } from "react";
import upsolveStats from "../../../content/onBuild/upsolveStats.json";
import useInterval from "../utils/useInterval";

const DebtIncrementer = (props) => {
  const [debt, setDebt] = useState(props.debt || upsolveStats.debtCleared.total);
  useInterval(() => {
    setDebt(debt + 1.157);
  }, 200);

  return Number(debt).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 });
};

export default DebtIncrementer;
